import { render } from "./CompactLanguageSelector.vue?vue&type=template&id=6894eb54&scoped=true&ts=true"
import script from "./CompactLanguageSelector.vue?vue&type=script&lang=ts"
export * from "./CompactLanguageSelector.vue?vue&type=script&lang=ts"

import "./CompactLanguageSelector.vue?vue&type=style&index=0&id=6894eb54&scoped=true&lang=scss"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6894eb54"]])

export default __exports__